<template>
  <div>
    <div
      id="on-boarding-dialog"
      class="modal fade ob-modal"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="isSaveToList ? 'saveToListTitle' : 'onBoardingTitle'"
    >
      <!-- One compact dialog for the whole flow, the sign-up steps and Save to list alike
           (a bottom sheet on phones). Each page brings its own header and footer:
           OnBoardingFrame.vue, or OnBoardingAddToListPage.vue for Save to list. -->
      <div class="modal-dialog ob-dialog" role="document">
        <div class="modal-content ob-content">
          <OnBoardingPageRouter />
        </div>
      </div>
    </div>
    <SaveToListPageNote />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { OnBoardingPage } from '../../utils/models/OnBoardingPage';
import OnBoardingPageRouter from './components/OnBoardingPageRouter.vue';
import SaveToListPageNote from './components/SaveToListPageNote.vue';

export default defineComponent({
  components: {
    OnBoardingPageRouter,
    SaveToListPageNote,
  },
  computed: {
    topPage() {
      return this.$store.getters['onBoarding/lastPage'];
    },
    isSaveToList() {
      return this.topPage === OnBoardingPage.AddTrailToList;
    },
  },
});
</script>

<style scoped>
/* A 460 px dialog (plus 16 px gutters) in the site's newer modal style (OptionsMenuModal). */
.ob-modal{
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-dialog.ob-dialog{
  width: auto;
  max-width: calc(460px + 32px);
  min-height: calc(100% - 3.5rem);
  margin: 1.75rem auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.modal-content.ob-content{
  min-height: 0;
  max-height: min(760px, calc(100vh - 3.5rem));
  max-height: min(760px, calc(100dvh - 3.5rem));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #1c1e22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}
/* The page router's wrapper: lets each page's body scroll inside the max height. */
.ob-content > div{
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

/* Phones: docked to the bottom as a sheet, like the site's other phone sheets. */
@media (max-width: 575.98px) {
  .modal-dialog.ob-dialog{
    max-width: none;
    min-height: 100%;
    margin: 0;
    padding: 0;
    justify-content: flex-end;
  }
  .ob-modal.fade .modal-dialog.ob-dialog{
    transform: translate(0, 100%);
  }
  .ob-modal.show .modal-dialog.ob-dialog{
    transform: none;
  }
  .modal-content.ob-content{
    width: 100%;
    max-height: 92vh;
    max-height: 92dvh;
    border-radius: 16px 16px 0 0;
    border-bottom: 0;
  }
}
</style>
